<div class="content">
  <mat-card appearance="outlined">
    <mat-card-content>
      <p>
        {{ "components.route-settings.parking-time-description" | translate }}
      </p>
      <mat-form-field>
        <mat-label>{{
          "components.route-settings.car-parking-time-label" | translate
        }}</mat-label>
        <input matInput id="car-parking-time-input" aria-label="Car parking time" [formControl]="carParkingTimeFormControl" />
        @if (carParkingTimeFormControl.invalid) {
          <mat-error>
            {{ "components.route-settings.car-parking-time.error" | translate }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{
          "components.route-settings.bike-parking-time-label" | translate
        }}</mat-label>
        <input matInput id="bike-parking-time-input" aria-label="Bike parking time" [formControl]="bikeParkingTimeFormControl" />
        @if (bikeParkingTimeFormControl.invalid) {
          <mat-error>
            {{
              "components.route-settings.bike-parking-time.error" | translate
            }}
          </mat-error>
        }
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <p>
        {{
          "components.route-settings.maximum-tour-length-description"
            | translate
        }}
      </p>
      <mat-form-field>
        <mat-label>
          {{
            "components.route-settings.maximum-tour-length-label" | translate
          }}</mat-label
        >
        <input matInput id="maximum-tour-length-input" aria-label="Maximum tour length" [formControl]="maximumTourLengthFormControl" />
        @if (maximumTourLengthFormControl.invalid) {
          <mat-error>
            {{
              "components.route-settings.maximum-tour-length-error" | translate
            }}
          </mat-error>
        }
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <p>
        {{ "components.route-settings.time-per-lead-description" | translate }}
      </p>
      <mat-form-field>
        <mat-label>{{
          "components.route-settings.time-per-lead-label" | translate
        }}</mat-label>
        <input matInput id="time-per-lead-input" aria-label="Time per lead" [formControl]="timePerLeadFormControl" />
        @if (timePerLeadFormControl.invalid) {
          <mat-error>
            {{ "components.route-settings.time-per-lead-error" | translate }}
          </mat-error>
        }
      </mat-form-field>
    </mat-card-content>
  </mat-card>
</div>
